import { Component, OnInit } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { AuthService } from '../../_services/auth.service';
import { UserService } from '../../_services/user.service';

@Component({
  selector: 'app-logout',
  template: ''
})
export class LogoutComponent implements OnInit {

  constructor(public _auth: AuthService,public _router: Router, public userService: UserService) { }

  ngOnInit() {
    this._auth
    .logout().then(
      ()=>{
      
      //  this._router.navigateByUrl('/auth/login')
      clearTimeout(this.userService.expTimeOutObject);
      window.location.replace('/auth/login');
      }
    )
  }

}
